export class Term {
  constructor({
    id,
    uuid,
    status,
    created_at,
    name = "",
    terms = "",
    file = "",
    creation_type = "",
    details = "",
    summary = "",
    deactivated_at = null,
    properties = {
      layout: "",
      id: ""
    },
    all_city = "",
    cities=[]
  }) {
    this.id = id
    this.uuid = uuid
    this.status = status
    this.createdAt = created_at
    this.termName = name
    this.termDesc = terms
    this.file = file
    this.format = creation_type
    this.details = details
    this.summary = summary
    this.deactivatedAt = deactivated_at
    this.properties = properties,
    this.validNationwide = all_city,
    this.cities = cities
  }
}
